import { Brand } from "./Brand";

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer__top">
        <div>
          <Brand inverse />
          <p>Clareza para comparar a estrutura financeira antes de construir a decisão.</p>
        </div>
        <div>
          <strong>Produto</strong>
          <a href="/#simulador">Simular</a>
          <a href="/metodologia">Como funciona</a>
          <a href="/admin">Configuração</a>
        </div>
        <div>
          <strong>Confiança</strong>
          <a href="/privacidade">Privacidade</a>
          <a href="/termos">Termos de uso</a>
          <a href="/acessibilidade">Acessibilidade</a>
        </div>
        <div>
          <strong>Suporte</strong>
          <a href="/sobre">Sobre e missão</a>
          <a href="/suporte">Contato e suporte</a>
          <a href="/seguranca">Segurança</a>
        </div>
      </div>
      <div className="site-footer__bottom">
        <span>© {new Date().getFullYear()} Alicerce</span>
        <span>Simulação informativa · não é proposta de crédito</span>
      </div>
    </footer>
  );
}

